import styled from 'styled-components';

export const CardsContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	max-width: 840px;
	margin: 0 auto;
`;

export const FoundationCard = styled.div`
	padding: 24px;
	border-radius: 12px;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ theme }) => theme.gray[0]};
`;

export const CardTitle = styled.h3`
	font-size: 18px;
	font-weight: 600;
	margin: 0 0 8px 0;
	color: ${({ theme }) => theme.gray[900]};
	user-select: text;
`;

export const CardDescription = styled.p`
	font-size: 14px;
	line-height: 1.5;
	margin: 0 0 16px 0;
	color: ${({ theme }) => theme.gray[600]};
	user-select: text;
`;

export const OverviewBody = styled.div`
	font-size: 14px;
	line-height: 1.6;
	color: ${({ theme }) => theme.gray[800]};
	white-space: pre-wrap;
	user-select: text;
`;

export const ModeRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	padding: 10px 0;
	border-bottom: 1px solid ${({ theme }) => theme.gray[200]};

	&:last-child {
		border-bottom: none;
		padding-bottom: 0;
	}
`;

export const ModeLabelInput = styled.input`
	width: 140px;
	font-size: 14px;
	font-family: 'Inter', sans-serif;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[1000]};
	background: ${({ theme }) => theme.gray[100]};
	border: 1px solid transparent;
	border-radius: 6px;
	padding: 4px 8px;
	transition: border-color 0.15s ease;

	&:hover {
		border-color: ${({ theme }) => theme.gray[200]};
	}

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.blue[500]};
	}
`;

export const ModeDefaultBadge = styled.span`
	font-size: 11px;
	font-weight: 500;
	color: ${({ theme }) => theme.gray[600]};
	background: ${({ theme }) => theme.gray[100]};
	border-radius: 4px;
	padding: 2px 6px;
	flex-shrink: 0;
	letter-spacing: 0.02em;
`;

export const ModeColorPicker = styled.div`
	position: relative;
	flex-shrink: 0;
`;

export const ModeSwatch = styled.button<{ $color: string }>`
	width: 32px;
	height: 32px;
	border-radius: 50%;
	border: 1px solid ${({ theme }) => theme.gray[200]};
	background-color: ${({ $color }) => $color};
	padding: 0;
	flex-shrink: 0;
	transition: border-color 0.15s ease, box-shadow 0.15s ease;

	&:hover {
		border-color: ${({ theme }) => theme.gray[400]};
		box-shadow: 0 0 0 2px ${({ theme }) => theme.gray[100]};
	}
`;

export const ModeColorPopover = styled.div`
	position: absolute;
	left: calc(100% + 8px);
	top: 50%;
	transform: translateY(-10%);
	z-index: 1000;
	background: ${({ theme }) => theme.gray[0]};
	border-radius: 8px;
	padding: 12px;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	border: 1px solid ${({ theme }) => theme.gray[200]};
	display: flex;
	flex-direction: column;
	gap: 8px;

	.react-colorful {
		width: 200px !important;
		height: 150px !important;
	}
`;

export const ModeColorHexInput = styled.input`
	font-size: 12px;
	font-family: 'Inter', sans-serif;
	color: ${({ theme }) => theme.gray[1000]};
	background: ${({ theme }) => theme.gray[100]};
	border: 1px solid ${({ theme }) => theme.gray[200]};
	border-radius: 4px;
	padding: 4px 8px;
	width: 100%;
	box-sizing: border-box;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.blue[500]};
	}
`;

export const FontWarningBanner = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 10px;
	padding: 10px 12px;
	border-radius: 6px;
	margin-bottom: 12px;
	font-size: 13px;
	line-height: 1.4;
	background: ${({ theme }) => `${theme.blue[500]}14`};
	border: 1px solid ${({ theme }) => theme.blue[500]};
	color: ${({ theme }) => theme.gray[800]};
`;

export const FontWarningText = styled.div`
	margin-top: 2px;
	flex: 1;
	user-select: text;
	line-height: 1.5;
	margin-bottom: 4px;
`;

export const FontWarningFontList = styled.span`
	font-weight: 600;
`;

export const FontWarningAction = styled.button`
	flex-shrink: 0;
	font-size: 12px;
	font-weight: 600;
	padding: 4px 10px;
	border-radius: 6px;
	border: 1px solid ${({ theme }) => theme.blue[500]};
	background: ${({ theme }) => theme.blue[500]};
	color: ${({ theme }) => theme.gray[0]};
	transition: background 0.15s ease, border-color 0.15s ease;

	&:hover {
		background: ${({ theme }) => theme.blue[400]};
		border-color: ${({ theme }) => theme.blue[400]};
	}

	&:disabled {
		background: ${({ theme }) => theme.blue[700]};
		border-color: ${({ theme }) => theme.blue[700]};
	}
`;
